import { render, staticRenderFns } from "./DirectMailDetail.vue?vue&type=template&id=0c2f8c30&"
import script from "./DirectMailDetail.vue?vue&type=script&lang=js&"
export * from "./DirectMailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports